module.exports = __webpack_public_path__ + "media/student_lending_solutions/simple-dece19c7.png";